/* eslint-disable react/require-default-props,react/jsx-props-no-spreading */
import Tab from '@mui/material/Tab'

import useStyles from './LinkTab.styles'

type LinkTabProps = {
    label?: string;
    href?: string;
    selected?: boolean;

}

function LinkTab({
    label,
    href,
    selected,
    ...rest
}: LinkTabProps) {
    const {
        classes, cx,
    } = useStyles()

    return (
        <Tab
            component="a"
            aria-current={selected ? 'page' : undefined}
            label={label}
            href={href}
            className={cx(classes.tab, selected ? classes.selectedTab : null)}
            data-testid={`link-tab-${label}`}
            {...rest}
        />
    )
}

export default LinkTab
